"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Off = void 0;
const Off = ({
  isEnabled,
  children
}) => !isEnabled && children;
exports.Off = Off;
